import { type CategoryLeaf, MAX_CATEGORY_NAME_LENGTH } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { RenameController } from '@/shared/lib';
import { InlineRenameForm } from '@/shared/ui';

interface CategoryNameCellProps {
  readonly category: CategoryLeaf;
  readonly rename: RenameController;
}

/** 이름 표시 — 수정 대상이면 인라인 입력, 아니면 텍스트. */
export const CategoryNameCell = ({ category, rename }: CategoryNameCellProps): ReactElement =>
  rename.target?.id === category.id ? (
    <InlineRenameForm
      ariaLabel={`${category.name} 새 이름`}
      name={rename.target.name}
      maxLength={MAX_CATEGORY_NAME_LENGTH}
      isPending={rename.target.isPending}
      onNameChange={rename.onChange}
      onSubmit={rename.onSubmit}
      onCancel={rename.onCancel}
    />
  ) : (
    <span>{category.name}</span>
  );
